import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { businessInfo } from '../mock';

export const Footer = ({ onContactClick }) => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const scrollToSection = (id) => {
    if (!isHomePage) {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          const offset = 80;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - offset;
          window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(id);
      if (element) {
        const offset = 80;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;
        window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
      }
    }
  };

  return (
    <footer className="bg-[#3E2723] text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="/logo-white.png" 
                alt="TradeMark Registry Logo" 
                className="h-12 w-auto object-contain"
              />
            </div>
            <p className="text-[#D7CCC8] mb-4 leading-relaxed">
              Your trusted partner for professional trademark registration services. Protecting your brand with expertise and dedication.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-[#D7CCC8]">Quick Links</h4>
            <ul className="space-y-2">
              {['Home', 'About', 'Services', 'Process', 'Pricing', 'FAQs'].map(item => (
                <li key={item}>
                  <button
                    onClick={() => scrollToSection(item.toLowerCase())}
                    className="text-white/80 hover:text-[#D7CCC8] transition-colors duration-300"
                  >
                    {item}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-[#D7CCC8]">Our Services</h4>
            <ul className="space-y-2">
              <li className="text-white/80">Trademark Search</li>
              <li className="text-white/80">Trademark Filing</li>
              <li className="text-white/80">Office Action Response</li>
              <li className="text-white/80">Trademark Monitoring</li>
              <li className="text-white/80">Brand Protection</li>
              <li className="text-white/80">Renewal Services</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-[#D7CCC8]">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#D7CCC8] flex-shrink-0 mt-1" />
                <span className="text-white/80">{businessInfo.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-[#D7CCC8] flex-shrink-0" />
                <a href={`tel:${businessInfo.phone}`} className="text-white/80 hover:text-[#D7CCC8] transition-colors">
                  {businessInfo.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-[#D7CCC8] flex-shrink-0" />
                <a href={`mailto:${businessInfo.email}`} className="text-white/80 hover:text-[#D7CCC8] transition-colors break-all">
                  {businessInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-[#8D6E63] pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/70 text-sm text-center md:text-left">
              © {currentYear} {businessInfo.name}. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm">
              <button
                onClick={() => navigate('/privacy-policy')}
                className="text-white/70 hover:text-[#D7CCC8] transition-colors"
              >
                Privacy Policy
              </button>
              <button
                onClick={() => navigate('/terms-conditions')}
                className="text-white/70 hover:text-[#D7CCC8] transition-colors"
              >
                Terms & Conditions
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
